import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { ProductEditPage, productQueryOptions, variantsQueryOptions } from '@/features/products';

export const Route = createFileRoute('/_authed/_active/org/products/$productId')({
  staticData: {
    tours: [
      'catalog.product-editor.basics',
      'catalog.product-editor.variants-media',
      'catalog.product-editor.selling',
    ],
  },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'products.read');
  },
  loader: async ({ context, params }) => {
    const [product] = await Promise.all([
      context.queryClient.query({ ...productQueryOptions(params.productId), staleTime: 'static' }),
      context.queryClient
        .query({ ...variantsQueryOptions(params.productId), staleTime: 'static' })
        .catch(() => undefined),
    ]);
    return { crumb: product.title };
  },
  component: ProductEditPage,
});
